import React from "react";
import "./styles/BoxFooter.scss";

const BoxFooter = (props) => <div className="boxFooter">{props.children}</div>;

export default BoxFooter;
